export class RenewalVehicle {
    constructor(
        public ResidentVehicleKey: number = null,
        public ResidentKey: number = null,
        public Year: string = '',
        public Make: string = '',
        public VehicleModel: string = '',
        public State: string = '',
        public Plate: string = '',
        public Color: string = '',

    ) { }
}
